{
  "familyId": "SWW-VT-DUBBEL",
  "questions": [
    {
      "id": "SWW-VT-DUBBEL-001",
      "familyId": "SWW-VT-DUBBEL",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_dubbel_dt",
      "questionType": "multiple_choice",
      "question": "De leerlingen ... hard voor de toets. (werken, verleden tijd meervoud)",
      "context": null,
      "options": ["werktten", "werkte", "werkten", "gewerkt"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "kofschipMnemonic",
          "showWhen": "wrong",
          "data": { "verb": "werken", "stem": "werk", "lastLetter": "k", "useTE": true, "label": "Kofschip bij meervoud VT" },
          "a11y": { "alt": "'t kofschip ezelsbruggetje: k zit in kofschip, dus uitgang -te(n)" }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Dubbele letters in meervoud",
            "content": "Stam 'werk' + uitgang -ten (meervoud, k in kofschip) = werkten. Geen dubbele t: de stam eindigt niet op t.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vt_dubbel_meervoud_kofschip",
      "variantIndex": 1,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Stam van 'werken' = 'werk'. De k zit in 't kofschip → uitgang -te(n). Meervoud 'de leerlingen' → -ten. Werk + ten = werkten. Geen dubbele t, want de stam eindigt op k, niet op t.",
        "solutionSteps": [
          "Bepaal de stam: werken → werk",
          "Kofschip: 'k' zit in kofschip → -te(n)",
          "'De leerlingen' is meervoud → -ten",
          "werk + ten = werkten (één t, want stam eindigt niet op t)"
        ],
        "distractorExplanations": {
          "0": "Hier is een extra t toegevoegd. 'Werktten' heeft een dubbele t te veel. De stam 'werk' eindigt niet op t, dus geen dubbele t nodig: werkten.",
          "1": "Hier is enkelvoud gebruikt bij een meervoud onderwerp. 'Werkte' is enkelvoud (hij/zij werkte). 'De leerlingen' is meervoud, dus -ten: werkten.",
          "2": "Correct! Stam 'werk' + uitgang -ten (meervoud) = werkten.",
          "3": "Hier is het voltooid deelwoord gebruikt zonder hulpwerkwoord. 'Gewerkt' hoort bij 'hebben gewerkt'. Hier zonder hulpwerkwoord, dus gewone verleden tijd: werkten."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.dt-overgeneralize", "label": "Extra t toegevoegd door regel verkeerd toe te passen", "optionIndex": 0 },
          { "id": "sww.vt-enkelvoud-bij-meervoud", "label": "Enkelvoud gebruikt bij meervoud onderwerp", "optionIndex": 1 },
          { "id": "sww.past-participle-ge-omitted", "label": "Voltooid deelwoord gebruikt zonder hulpwerkwoord", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-VT-DUBBEL-002",
      "familyId": "SWW-VT-DUBBEL",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_dubbel_dt",
      "questionType": "multiple_choice",
      "question": "Hij ... de hele avond met zijn vrienden. (praten, verleden tijd)",
      "context": null,
      "options": ["praate", "praatte", "pratte", "pratete"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "kofschipMnemonic",
          "showWhen": "wrong",
          "data": { "verb": "praten", "stem": "praat", "lastLetter": "t", "useTE": true, "label": "Kofschip bij dubbele t" }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Dubbele t bij verleden tijd",
            "content": "Stam 'praat' (eindigt op t). Kofschip: t zit in kofschip → -te. praat + te = praatte (dubbel t).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vt_dubbel_stam_op_t",
      "variantIndex": 2,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Stam van 'praten' = 'praat'. De t zit in 't kofschip → uitgang -te. Praat + te = praatte. Twee t's: één van de stam, één van de uitgang -te.",
        "solutionSteps": [
          "Bepaal de stam: praten → praat",
          "Kofschip: 't' zit in kofschip → -te",
          "praat + te = praatte",
          "Check: één t van de stam + één t van -te = twee t's"
        ],
        "distractorExplanations": {
          "0": "Hier ontbreekt een t. 'Praate' mist de t van de uitgang. Stam 'praat' + uitgang -te = praatte (twee t's).",
          "1": "Correct! Stam 'praat' (eindigt op t) + uitgang -te = praatte.",
          "2": "Hier is de stam verkeerd geschreven. 'Pratte' heeft maar één a, maar de stam is 'praat' (met dubbele a, lange klank).",
          "3": "Hier is -te dubbel toegevoegd. 'Pratete' heeft een extra lettergreep. De regel: stam + te = praatte."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.vt-uitgang-t-mist", "label": "Uitgangs-t weggelaten (stam-t als uitgang gezien)", "optionIndex": 0 },
          { "id": "sww.stem-extraction-error", "label": "Stam ingekort (lange klinker fout)", "optionIndex": 2 },
          { "id": "sww.vt-uitgang-dubbel", "label": "Uitgang dubbel toegevoegd", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-VT-DUBBEL-003",
      "familyId": "SWW-VT-DUBBEL",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_dubbel_dt",
      "questionType": "multiple_choice",
      "question": "Zij ... op alle vragen. (antwoorden, verleden tijd enkelvoud)",
      "context": null,
      "options": ["antwoorde", "antwoordte", "antwoordede", "antwoordde"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "kofschipMnemonic",
          "showWhen": "wrong",
          "data": { "verb": "antwoorden", "stem": "antwoord", "lastLetter": "d", "useTE": false, "label": "Kofschip bij dubbele d" }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Dubbele d bij verleden tijd",
            "content": "Stam 'antwoord' (eindigt op d). D zit NIET in kofschip → -de. antwoord + de = antwoordde (dubbel d).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vt_dubbel_stam_op_d",
      "variantIndex": 3,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Stam van 'antwoorden' = 'antwoord'. De d zit NIET in 't kofschip → uitgang -de. Antwoord + de = antwoordde. Twee d's: één van de stam, één van de uitgang -de.",
        "solutionSteps": [
          "Bepaal de stam: antwoorden → antwoord",
          "Kofschip: 'd' zit NIET in kofschip → -de",
          "antwoord + de = antwoordde",
          "Check: één d van de stam + één d van -de = twee d's"
        ],
        "distractorExplanations": {
          "0": "Hier ontbreekt een d. 'Antwoorde' mist de d van de uitgang. Stam 'antwoord' + uitgang -de = antwoordde.",
          "1": "Hier is -te gebruikt in plaats van -de. Maar 'd' zit NIET in 't kofschip, dus de uitgang is -de (niet -te): antwoordde.",
          "2": "Hier is -de dubbel toegevoegd. 'Antwoordede' heeft een extra lettergreep. De regel: stam + de = antwoordde.",
          "3": "Correct! Stam 'antwoord' (eindigt op d) + uitgang -de = antwoordde."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.vt-uitgang-d-mist", "label": "Uitgangs-d weggelaten (stam-d als uitgang gezien)", "optionIndex": 0 },
          { "id": "sww.kofschip-misapplied", "label": "Kofschip-regel verkeerd toegepast (-te i.p.v. -de)", "optionIndex": 1 },
          { "id": "sww.vt-uitgang-dubbel", "label": "Uitgang dubbel toegevoegd", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "SWW-VT-DUBBEL-004",
      "familyId": "SWW-VT-DUBBEL",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_dubbel_dt",
      "questionType": "error_spotting",
      "question": "Vind de fouten met dubbele letters in de verleden tijd.",
      "context": null,
      "correctAnswer": 0,
      "data": {
        "text": "Wij praaten de hele middag in de tuin. Hij antwoorde direct op de mail en brande zich aan het vuur.",
        "errors": [
          { "word": "praaten", "position": 1, "correction": "praatten", "explanation": "Stam 'praat' + ten (meervoud) = praatten. Stam-t plus uitgangs-t geeft dubbele t." },
          { "word": "antwoorde", "position": 9, "correction": "antwoordde", "explanation": "Stam 'antwoord' + de = antwoordde. Stam-d plus uitgangs-d geeft dubbele d." },
          { "word": "brande", "position": 15, "correction": "brandde", "explanation": "Stam 'brand' + de = brandde. Stam-d plus uitgangs-d geeft dubbele d." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Stam + uitgang = dubbele letter", "content": "Stap 1: bepaal de stam. Stap 2: kofschip-check (-te of -de). Stap 3: plak stam en uitgang aaneen. Als de stam op t eindigt en je krijgt -te, of op d en -de, dan krijg je een DUBBELE letter.", "icon": "lightbulb" } }
      ],
      "conceptId": "vt_dubbel_error_spotting_zinnen",
      "variantIndex": 4,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Drie fouten met dubbele letters. 'Praaten' moet 'praatten' zijn (stam praat + ten geeft dubbele t). 'Antwoorde' moet 'antwoordde' zijn (stam antwoord + de geeft dubbele d). 'Brande' moet 'brandde' zijn (stam brand + de geeft dubbele d). De uitgangsletter wordt vaak vergeten omdat de stam al op die letter eindigt.",
        "solutionSteps": [
          "Voor elke vorm: bepaal de stam",
          "Kofschip-check: -te of -de?",
          "Plak uitgang aan stam, let op dubbele letter",
          "Vergelijk met de geschreven vorm"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.vt-uitgang-t-mist", "label": "Uitgangs-t weggelaten (stam-t als uitgang gezien)" },
          { "id": "sww.vt-uitgang-d-mist", "label": "Uitgangs-d weggelaten (stam-d als uitgang gezien)" }
        ]
      }
    },
    {
      "id": "SWW-VT-DUBBEL-005",
      "familyId": "SWW-VT-DUBBEL",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_dubbel_dt",
      "questionType": "fill_in",
      "question": "Vul in: 'Hij ... de kinderen uit het water.' (redden, verleden tijd enkelvoud) Typ het hele woord.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": { "acceptedAnswers": ["redde"], "caseSensitive": false, "placeholder": "redde" },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "kofschipMnemonic",
          "showWhen": "wrong",
          "data": { "verb": "redden", "stem": "red", "lastLetter": "d", "useTE": false, "label": "Kofschip bij dubbele d" }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Dubbele d bij verleden tijd",
            "content": "Stam 'red' (eindigt op d). D zit NIET in kofschip → -de. red + de = redde (dubbel d).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vt_dubbel_fill_redde",
      "variantIndex": 5,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Stam van 'redden' = 'red'. De d zit NIET in 't kofschip → uitgang -de. Red + de = redde. De dubbele d ontstaat doordat de stam op d eindigt en de uitgang met d begint.",
        "solutionSteps": [
          "Bepaal de stam: redden → red",
          "Kofschip-check: d zit NIET in kofschip → -de",
          "red + de = redde (dubbel d)"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.vt-uitgang-d-mist", "label": "Mogelijke fout: stam-d als uitgang gezien (rede)" },
          { "id": "sww.kofschip-misapplied", "label": "Mogelijke fout: kofschip verkeerd → -te (redte)" }
        ]
      }
    },
    {
      "id": "SWW-VT-DUBBEL-006",
      "familyId": "SWW-VT-DUBBEL",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_dubbel_dt",
      "questionType": "error_spotting",
      "question": "Vind de werkwoordspellingfouten in deze tekst over dubbele letters in de verleden tijd.",
      "correctAnswer": 0,
      "data": {
        "text": "De kok bakte een taart en reden snel naar de winkel. Daarna paktte hij de spullen in en stuurde een bericht.",
        "errors": [
          { "word": "reden", "position": 6, "correction": "reed", "explanation": "'Rijden' is een sterk werkwoord: hij reed (niet reden — dat is meervoud)." },
          { "word": "paktte", "position": 12, "correction": "pakte", "explanation": "Stam 'pak' + te = pakte. De k zit in kofschip → -te. Geen dubbele t nodig want de stam eindigt niet op t." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "verbTable",
          "showWhen": "wrong",
          "data": {
            "verb": "pakken",
            "forms": {
              "stam": "pak",
              "tt_ik": "pak",
              "tt_jij": "pakt",
              "tt_hij": "pakt",
              "vt_ik": "pakte",
              "vt_wij": "pakten",
              "vd": "gepakt"
            }
          }
        },
        {
          "type": "kofschipMnemonic",
          "showWhen": "wrong",
          "data": { "verb": "pakken", "stem": "pak", "lastLetter": "k", "useTE": true, "label": "Kofschip bij enkele t" }
        }
      ],
      "conceptId": "vt_dubbel_error_spotting",
      "variantIndex": 6,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Twee fouten: 1) 'reden' moet 'reed' zijn — rijden is een sterk werkwoord (hij reed, enkelvoud). 2) 'paktte' moet 'pakte' zijn — stam 'pak' eindigt op k (kofschip) → pak + te = pakte, geen dubbele t.",
        "solutionSteps": [
          "Controleer elk werkwoord: sterk of zwak?",
          "'rijden' is sterk → hij reed (niet reden)",
          "'pakken' → stam 'pak', k in kofschip → pakte",
          "Dubbele t alleen als stam op t eindigt — bij 'pak' niet"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.irregular-verb-regularized", "label": "Sterk werkwoord verkeerd vervoegd of meervoud i.p.v. enkelvoud" },
          { "id": "sww.dt-overgeneralize", "label": "Onnodige dubbele t bij stam die niet op t eindigt" }
        ]
      }
    },
    {
      "id": "SWW-VT-DUBBEL-007",
      "familyId": "SWW-VT-DUBBEL",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_dubbel_dt",
      "questionType": "fill_in",
      "question": "Vul de verleden tijd in: De brandweerman ... het kind uit het water. (redden, enkelvoud)",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["redde"],
        "caseSensitive": false,
        "placeholder": "verleden tijd van redden"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "kofschipMnemonic",
          "showWhen": "wrong",
          "data": { "verb": "redden", "stem": "red", "lastLetter": "d", "useTE": false, "label": "Kofschip bij dubbele d" }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Dubbele medeklinker in VT",
            "content": "Stam van 'redden' = 'red'. De d zit NIET in kofschip → -de. Red + de = redde (dubbel d: één van de stam, één van de uitgang).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vt_dubbel_fill_in_context",
      "variantIndex": 7,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Stam van 'redden' = 'red'. De d zit NIET in 't kofschip → uitgang -de. Red + de = redde. De dubbele d ontstaat doordat de stam op d eindigt en de uitgang met d begint.",
        "solutionSteps": [
          "Bepaal de stam: redden → red",
          "Kofschip-check: d zit NIET in kofschip → -de",
          "red + de = redde (dubbel d)"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.vt-uitgang-d-mist", "label": "Mogelijke fout: 'rede' (uitgangs-d vergeten)" },
          { "id": "sww.kofschip-misapplied", "label": "Mogelijke fout: 'redte' (kofschip fout toegepast)" }
        ]
      }
    },
    {
      "id": "SWW-VT-DUBBEL-008",
      "familyId": "SWW-VT-DUBBEL",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_dubbel_dt",
      "questionType": "matching",
      "question": "Koppel elk werkwoord aan de juiste verleden-tijdvorm (enkelvoud).",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "praten", "right": "praatte" },
          { "left": "antwoorden", "right": "antwoordde" },
          { "left": "zetten", "right": "zette" },
          { "left": "branden", "right": "brandde" },
          { "left": "wachten", "right": "wachtte" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stam + uitgang",
            "content": "Stam bepalen, kofschip-check, stam + te/de aanplakken. Stam eindigt op t of d? Dan krijg je een dubbele letter.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vt_dubbel_matching",
      "variantIndex": 8,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Voor elk werkwoord: bepaal de stam, kofschip-check, plak uitgang aan. praten → praat+te = praatte; antwoorden → antwoord+de = antwoordde; zetten → zet+te = zette; branden → brand+de = brandde; wachten → wacht+te = wachtte. Alle vijf hebben een dubbele letter omdat de stam op t of d eindigt.",
        "solutionSteps": [
          "Bepaal voor elk werkwoord de stam",
          "Kofschip-check: -te (k,f,s,ch,p,t) of -de (rest)",
          "Plak uitgang aan stam — dubbele letter ontstaat bij stam op t of d"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.vt-uitgang-t-mist", "label": "Stam-t/d als uitgang verwerken" },
          { "id": "sww.kofschip-misapplied", "label": "Kofschip-keuze verwisselen" }
        ]
      }
    },
    {
      "id": "SWW-VT-DUBBEL-009",
      "familyId": "SWW-VT-DUBBEL",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_dubbel_dt",
      "questionType": "categorize",
      "question": "Sorteer elke verleden-tijdvorm op het soort uitgang.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Dubbele t (stam-t + -te)", "Dubbele d (stam-d + -de)", "Geen dubbele letter"],
        "items": [
          { "text": "praatte", "correctCategory": 0 },
          { "text": "zette", "correctCategory": 0 },
          { "text": "wachtte", "correctCategory": 0 },
          { "text": "antwoordde", "correctCategory": 1 },
          { "text": "redde", "correctCategory": 1 },
          { "text": "brandde", "correctCategory": 1 },
          { "text": "pakte", "correctCategory": 2 },
          { "text": "werkte", "correctCategory": 2 },
          { "text": "leefde", "correctCategory": 2 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wanneer een dubbele letter?",
            "content": "Stam op -t + -te = dubbele t (praat+te). Stam op -d + -de = dubbele d (red+de). Stam op andere letter = nooit dubbel (pak+te = pakte).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vt_dubbel_categorize",
      "variantIndex": 9,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Een dubbele letter ontstaat alleen als de stam op t of d eindigt EN de uitgang met dezelfde letter begint. praatte/zette/wachtte → stam op t + uitgang -te. antwoordde/redde/brandde → stam op d + uitgang -de. pakte/werkte/leefde → stam op andere letter (k, k, f) → geen dubbel.",
        "solutionSteps": [
          "Voor elke vorm: bepaal de stam",
          "Eindigt de stam op t? + uitgang -te → dubbele t",
          "Eindigt de stam op d? + uitgang -de → dubbele d",
          "Anders → geen dubbele letter"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.dt-overgeneralize", "label": "Onnodige dubbele letter bij stam die niet op t/d eindigt" }
        ]
      }
    },
    {
      "id": "SWW-VT-DUBBEL-010",
      "familyId": "SWW-VT-DUBBEL",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_dubbel_dt",
      "questionType": "ordering",
      "question": "Zet de stappen op volgorde om de verleden tijd van 'antwoorden' (enkelvoud) goed te spellen.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": [
          "Bepaal de stam: antwoorden → antwoord",
          "Kijk naar de laatste letter van de stam: 'd'",
          "Kofschip-check: 'd' zit NIET in kofschip → uitgang -de",
          "Plak stam en uitgang aaneen: antwoord + de",
          "Resultaat: antwoordde (dubbel d — één van de stam, één van -de)"
        ],
        "correctOrder": [0, 1, 2, 3, 4]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vaste stappenvolgorde",
            "content": "1. Stam. 2. Laatste letter bekijken. 3. Kofschip-check. 4. Aaneenplakken. 5. Resultaat checken. Deze volgorde werkt altijd.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vt_dubbel_ordering_procedure",
      "variantIndex": 10,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "De procedure heeft een vaste volgorde: eerst de stam, dan de laatste letter bekijken, dan kofschip-check, dan aaneenplakken, en als laatste het resultaat lezen. Als je deze volgorde aanhoudt, kun je nooit fout zitten.",
        "solutionSteps": [
          "1) Stam bepalen",
          "2) Laatste letter bekijken",
          "3) Kofschip-check",
          "4) Aaneenplakken",
          "5) Resultaat lezen"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.stem-extraction-error", "label": "Verkeerde volgorde of stam-stap overgeslagen" }
        ]
      }
    }
  ]
}